import { render, staticRenderFns } from "./AwsWizard.vue?vue&type=template&id=2a5ccea8&"
import script from "./AwsWizard.vue?vue&type=script&lang=js&"
export * from "./AwsWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports